
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/ando",
      function () {
        return require("private-next-pages/cases/ando/index.tsx");
      }
    ]);
  